import { contract as basemaps } from "./basemaps/v1alpha1";

export const contract = {
  basemaps,
} as const;
